var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-panel"},[_c('div',{staticClass:"config-panel__header"},[_c('h2',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }